import * as actionTypes from "../actions/actionTypes";
const initialState = {
	user: null,
	userDoesNotExist: false,
	selectedUser: null,
};

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.USER_DOES_NOT_EXIST:
			return Object.assign({}, state, { userDoesNotExist: true });
		case actionTypes.GET_USER_SUCCESS:
			return Object.assign({}, state, { user: action.user });
		case actionTypes.SELECT_USER_SUCCESS:
			return Object.assign({}, state, {
				selectedUser: action.user,
			});
		default:
			return state;
	}
}
